import React from 'react';
import { AnimateOnScroll } from '../AnimateOnScroll';
import { ShieldCheckIcon, HeartIcon, DropletsIcon, ActivityIcon, SparklesIcon, SmileIcon, SunIcon } from 'lucide-react';
const benefits = [{
  icon: ShieldCheckIcon,
  text: 'Improved vaginal tightness and tone'
}, {
  icon: HeartIcon,
  text: 'Enhanced sexual satisfaction and intimacy'
}, {
  icon: DropletsIcon,
  text: 'Alleviation of vaginal dryness and discomfort'
}, {
  icon: ActivityIcon,
  text: 'Reduction in urinary incontinence symptoms'
}, {
  icon: SparklesIcon,
  text: 'Improved vaginal health and tissue quality'
}, {
  icon: SmileIcon,
  text: 'Enhanced self-confidence and body image'
}, {
  icon: SunIcon,
  text: 'Potential for increased lubrication and natural moisture'
}];
export function DVBenefits() {
  return <section className="bg-[#ECECEC] py-[60px] lg:py-[100px]" data-id="element-988">
      <div className="max-w-[1200px] mx-auto px-6 lg:px-8" data-id="element-989">
        <AnimateOnScroll className="text-center flex flex-col items-center mb-12" data-id="element-990">
          <h2 className="text-[28px] lg:text-[44px] uppercase text-black leading-tight mb-4 font-[600] font-[Poppins,_sans-serif]" data-id="element-991">
            BENEFITS OF VAGINAL REJUVENATION
          </h2>

          <p className="font-serif italic text-[#333333] text-[17px] leading-[1.7] max-w-[700px] mb-6" data-id="element-992">
            Vaginal rejuvenation with the diVa laser system can enhance overall
            vaginal health by addressing a variety of concerns:
          </p>

          <div className="w-[40px] h-[2px] bg-[#FF1493]" data-id="element-993"></div>
        </AnimateOnScroll>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6" data-id="element-994">
          {benefits.map((benefit, index) => <AnimateOnScroll key={index} delay={index * 60} data-id="element-995">
              <div className="bg-white p-7 shadow-[0_4px_16px_rgba(0,0,0,0.06)] text-center h-full group hover:shadow-[0_8px_24px_rgba(0,0,0,0.1)] transition-shadow duration-300" data-id="element-996">
                <benefit.icon size={36} strokeWidth={1.5} className="text-[#FF1493] mx-auto mb-4 group-hover:scale-110 transition-transform duration-300" data-id="element-997" />
                <p className="text-[#333333] text-[15px] leading-[1.5] font-body" data-id="element-998">
                  {benefit.text}
                </p>
              </div>
            </AnimateOnScroll>)}
        </div>
      </div>
    </section>;
}